import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LocalRepository } from "@shared/helper/local-repository";
import { ServiceResult } from '@shared/helper/service-result';
import { TServiceResult } from '@shared/helper/t-service-result';
import { BooksDetails } from '@shared/model/bookModels/merge-book-model';
import { HttpBaseService } from "@shared/service/base_services/http_base.service";
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class MergeBooksAggrService extends HttpBaseService {

    constructor() {
        const repo = inject(LocalRepository);
        const http = inject(HttpClient);

        super(repo, http, 'bookmng')
    }

    compareSeveralBook(idies: string[]): Observable<TServiceResult<BooksDetails[]>> {
        return this.http.post<TServiceResult<BooksDetails[]>>(`${this.apiUrl}/CompareSeveralBooks`, idies)
    }

    convertTwoBooks(sourceId: string, destinationId: string): Observable<ServiceResult> {
        const payload = {
            sourceId: sourceId,
            destinationId: destinationId
        }
        return this.http.post<ServiceResult>(`${this.apiUrl}/ConvertBook`, payload);
    }

    convertBookWithDependency(sourceId: string, destinationId: string): Observable<TServiceResult<string>> {
        const payload = {
            sourceId: sourceId,
            destinationId: destinationId
        }
        return this.http.post<TServiceResult<string>>(`${this.apiUrl}/convertBookWithDependencyCheck`, payload);
    }

}
